{
  "Target1Label": "Obiettivo 1:",
  "Target1Placeholder": "15",
  "Target2Label": "Obiettivo 2:",
  "Target2Placeholder": "30",
  "Target3Label": "Obiettivo 3:",
  "Target3Placeholder": "60",
  "Target4Label": "Obiettivo 4:",
  "Target4Placeholder": "90",
  "Target5Label": "Obiettivo 5:",
  "Target5Placeholder": "120",
  "Target6Label": "Obiettivo 6:",
  "Target6Placeholder": "300",
  "TargetUnit": "s",
  "ResetanswertargetsButtonLabel": "Azzeramento degli obiettivi di risposta",
  "ResetanswertargetsPrompt": "È sicuro di voler ripristinare tutte e 6 le impostazioni della soglia di durata della risposta alle chiamate in entrata ai valori predefiniti?",
  "ResetanswertargetsPromptButtonConfirmLabel": "Confermare",
  "ResetanswertargetsPromptButtonCancelLabel": "Annullamento",
  "AnswerPerformance_SectionHeader": "Risposta Prestazioni",
  "AnswerPerformance_SectionPara": "È inoltre possibile regolare in modo specifico le soglie di durata della risposta target, utilizzate dalle sette varianti di statistica delle prestazioni delle risposte in entrata di tipo \"Risponde <= Xs\".",
  "NAME": "AnswerPerformance"
}